import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export class AdminReseller {
  resellerId: number

  name: string

  email?: string

  phoneNumber?: string

  documentCpfCnpj: string

  status: EEnableStatusType

  referralCode: string

  currentCommissionPlanEntityId?: number

  currentCommissionPlanName?: string

  totalClients: number

  activeClients: number

  commissionAccrued: number

  commissionPaid: number

  commissionPending: number

  createdAt: string

  constructor(data: Partial<AdminReseller> = {}) {
    this.resellerId = data.resellerId ?? 0

    this.name = data.name ?? ""

    this.email = data.email

    this.phoneNumber = data.phoneNumber

    this.documentCpfCnpj = data.documentCpfCnpj ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.referralCode = data.referralCode ?? ""

    this.currentCommissionPlanEntityId = data.currentCommissionPlanEntityId

    this.currentCommissionPlanName = data.currentCommissionPlanName

    this.totalClients = data.totalClients ?? 0

    this.activeClients = data.activeClients ?? 0

    this.commissionAccrued = data.commissionAccrued ?? 0

    this.commissionPaid = data.commissionPaid ?? 0

    this.commissionPending = data.commissionPending ?? 0

    this.createdAt = data.createdAt ?? ""
  }
}
